/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import XhtmlEntry from "./JoditEditor";
import { ButtonWithConfirmModal } from "../components/ConfirmModal";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const DisplayFromFHIRXhtml = ({ xhtml }) => {
    if (xhtml) {
        if (Array.isArray(xhtml) || typeof xhtml !== "string") {
            return <>[ERROR: Xhtml data not interpretable.]</>;
        }
        try {
            return <span>
                <ReactMarkdown children={xhtml} rehypePlugins={[rehypeRaw]} /></span>
        } catch (e) {
            return <>[ERROR: Problem with the xhtml format. {e}] {xhtml}</>;
        }

    } else {
        return <></>
    }
}

const clearDivWrapper = (divText) => {
    if (divText && typeof (divText) === "string") {
        if (divText.substring(0, 42) === '<div xmlns="http://www.w3.org/1999/xhtml">' && divText.substring(divText.length - 6) === '</div>') {
            divText = divText.substring(42, divText.length - 6);
        }
    }
    return divText;
};

const emptyTextNoData = {
    "status": "empty",
    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
};

const NarrativeEntry = ({ elementName, startingValue, setResourceState,
    generatedNarrative, calledFrom }) => {

    const [narrativeState, setNarrativeState] = useState({});
    const [narrativeDivState, setNarrativeDivState] = useState({});
    const [startingDivValueState, setStartingDivValueState] = useState({});
    const [divFromGeneratedNarrativeState, setDivFromGeneratedNarrativeState] = useState(false);
    const [generateNarrativeClickedState, setGenerateNarrativeClickedState] = useState(false);
    const [remountXhtmlEntry, setRemountXhtmlEntry] = useState(true);

    useEffect(() => {
        let startingNarrative = {
            "status": "empty",
            "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
        };
        if (startingValue) {
            if (startingValue.extension) { startingNarrative.extension = startingValue.extension; }
            if (startingValue.status) { startingNarrative.status = startingValue.status; }
            if (startingValue.div) { startingNarrative.div = startingValue.div; }
        }
        let startingDivTextValue = clearDivWrapper(startingNarrative.div);
        let startingDivValue = { "divText": startingDivTextValue };
        setNarrativeState(JSON.parse(JSON.stringify(startingNarrative)));
        setNarrativeDivState(startingDivValue);
        setStartingDivValueState(startingDivValue);
    }, []);

    useEffect(() => {
        if (remountXhtmlEntry === false) {
            setRemountXhtmlEntry(true);
        }
    }, [remountXhtmlEntry]);

    useEffect(() => {
        if (generateNarrativeClickedState === true) {
            setNarrativeState(generatedNarrative);
            let divText = clearDivWrapper(generatedNarrative.div);
            let divValue = { "divText": divText };
            setNarrativeDivState(divValue);
            setGenerateNarrativeClickedState(false);
            setDivFromGeneratedNarrativeState(true);
            setRemountXhtmlEntry(false);
        }
    }, [generateNarrativeClickedState]);

    useEffect((() => {
        if (Object.keys(narrativeState).length) {
            let newNarrative = {};
            if (narrativeState.extension) { newNarrative.extension = narrativeState.extension; }
            if (narrativeState.status) { newNarrative.status = narrativeState.status; }
            if (narrativeState.div) { newNarrative.div = narrativeState.div; }
            if (Object.keys(newNarrative).length === 0 ||
                (newNarrative.status === "empty" && !newNarrative.div && !newNarrative.extension)) {
                newNarrative = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newNarrative } });
        }
        if (divFromGeneratedNarrativeState === true) {//TODO -- untested if this if clause is needed
            setDivFromGeneratedNarrativeState(false);
        }
    }), [narrativeState]);

    useEffect((() => {
        if (divFromGeneratedNarrativeState === true) {
            setDivFromGeneratedNarrativeState(false);
        } else if (divFromGeneratedNarrativeState === false && (startingDivValueState.divText !== narrativeDivState.divText) &&
            (("<p>" + startingDivValueState.divText + "</p>") !== narrativeDivState.divText)
        ) {
            if (narrativeState.status === "generated" && generatedNarrative?.status === "generated" &&
                narrativeDivState.divText === clearDivWrapper(generatedNarrative.div)
            ) {
                //pass
            } else if ((narrativeDivState.divText || narrativeDivState.divText === "0") &&
                narrativeDivState.divText !== '[No data]' &&
                narrativeDivState.divText !== '[No data.]' &&
                narrativeDivState.divText !== '<p>[No data.]</p>' &&
                narrativeDivState.divText !== '<p><br></p>' &&
                narrativeDivState.divText !== '<p><br/></p>' && narrativeDivState.divText !== '<p></p>') {
                setNarrativeState(prevState => { return { ...prevState, "status": "additional", "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + narrativeDivState.divText + "</div>" } });
            } else if (narrativeDivState.divText) {
                setNarrativeState(prevState => { return { ...prevState, "status": "empty", "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + narrativeDivState.divText + "</div>" } });
            } else {
                setNarrativeState(prevState => { return { ...prevState, "status": "empty", "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>' } });
            }
        }
    }), [narrativeDivState]);

    return <div>
        {(narrativeState.status) &&
            <>
                {(narrativeState.status === "generated" && 
                    JSON.stringify(generatedNarrative) !== JSON.stringify(narrativeState)) &&
                    <p><b>NOTE: The Resource Content has changed. Do you want to re-click Generate Natural Language Summary?</b></p>}
                {generatedNarrative && <ButtonWithConfirmModal buttonContent="Generate Natural Language Summary"
                    message="This will overwrite the manually edited summary with a generated summary."
                    conditionForConfirmModal={() => {
                        return narrativeState.status === "additional";
                    }}
                    functionIfConfirmed={() => {
                        setGenerateNarrativeClickedState(true);
                    }}
                />}
                <p style={{ marginBottom: "0px" }}><b>Natural language summary: </b>
                    (status: {narrativeState.status === "additional" ? "manually edited" : narrativeState.status})</p>
                <div style={{ marginLeft: "24px" }}>
                    {remountXhtmlEntry === true &&
                        <XhtmlEntry elementName='divText'
                            startingValue={narrativeDivState.divText} setResourceState={setNarrativeDivState} />
                    }
                </div>
            </>}
    </div>
};

export default NarrativeEntry;
export { emptyTextNoData, DisplayFromFHIRXhtml, clearDivWrapper };